var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 68,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-8.1%",
    y: "-4.9%",
    width: "116.2%",
    height: "119.5%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-22.2%",
    y: "-12.9%",
    width: "144.3%",
    height: "151.7%",
    filterUnits: "objectBoundingBox",
    id: "e"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.261063156 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.388 0c16.928 0 30.65 13.79 30.65 30.8s-13.722 30.8-30.65 30.8c-16.927 0-30.65-13.79-30.65-30.8 0-3.671.64-7.193 1.812-10.458l-.48.022-.537.008C7.037 20.372 0 16.661 0 10.587c0-2.682 1.494-5.116 3.91-6.882 5.298-3.873 13.95-3.873 19.247 0 .875.64 1.63 1.366 2.235 2.161A30.405 30.405 0 0 1 43.388 0z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.587c0-2.682 1.495-5.116 3.91-6.882 5.298-3.873 13.95-3.873 19.247 0 2.417 1.766 3.911 4.2 3.911 6.882 0 6.074-7.037 9.785-13.533 9.785a20.77 20.77 0 0 1-2.126-.117L3.662 24l1.667-5.618C2.187 16.479 0 14.013 0 10.587",
    id: "d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.184 .8)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.055 .8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.803 10.904.048-.073.707-.912c2.366-3.027 4.015-4.872 4.995-5.572a.59.59 0 0 1 .82.136c.19.263.13.63-.133.817l-.176.134c-.865.694-2.333 2.352-4.372 4.944l-.74.95.887 3.744a.583.583 0 0 1-.353.678l-.083.025a.59.59 0 0 1-.68-.355l-.027-.083-.95-4.016a.584.584 0 0 1 .057-.417z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 8.071,
    cy: 4.704,
    rx: 4.681,
    ry: 4.704
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EF6461",
    cx: 8.071,
    cy: 4.704,
    rx: 2.341,
    ry: 2.352
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M43.631 16.088h3.288c12.665 0 22.932 10.267 22.932 22.932v15.876a7.056 7.056 0 0 1-7.056 7.056h-35.04a7.056 7.056 0 0 1-7.056-7.056V39.02c0-12.665 10.267-22.932 22.932-22.932z",
    fill: "#EF6461",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.972 16.088c-12.665 0-22.932 10.267-22.932 22.932v15.876a7.056 7.056 0 0 0 7.056 7.056h-2.341a7.056 7.056 0 0 1-7.056-7.056V39.02c0-12.665 10.267-22.932 22.932-22.932z",
    fill: "#FFF",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#FFF",
    strokeWidth: 1.176,
    fill: "#FFF",
    mask: "url(#c)",
    cx: 47.616,
    cy: 43.136,
    rx: 11.115,
    ry: 11.172
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1 23.144c3.567 0 7.013.85 10.097 2.451a1.768 1.768 0 0 1 .753 2.378 1.751 1.751 0 0 1-2.366.756 18.354 18.354 0 0 0-8.485-2.057c-3.128 0-6.135.773-8.799 2.224a1.751 1.751 0 0 1-2.38-.71 1.768 1.768 0 0 1 .707-2.391A21.839 21.839 0 0 1 47.1 23.144z",
    fill: "#000",
    fillRule: "nonzero",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.616 37.256a5.81 5.81 0 0 1 2.175.42 2.355 2.355 0 0 0-1.005 1.932 2.346 2.346 0 0 0 2.34 2.352c.797 0 1.5-.4 1.923-1.01a5.89 5.89 0 0 1 .418 2.186c0 3.247-2.62 5.88-5.851 5.88-3.232 0-5.852-2.633-5.852-5.88s2.62-5.88 5.852-5.88z",
    fill: "#000",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 27.068 0)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#e)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotIcon);
export default __webpack_public_path__ + "static/media/botIcon.716a180372a48d5d5134f49691589b3b.svg";
export { ForwardRef as ReactComponent };